import React from 'react';
import { useSelector } from 'react-redux';

import UserDateFormat from '../../../components/user-date-format/index';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const CreatedDateColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret || !ret.createdDateTime) {
    return '';
  }

  return <UserDateFormat value={ret.createdDateTime} />;
};

export const CreatedDate = {
  getMessageDescriptor: () => messages.createdDate,
  id: 'created-date',

  render: ({ fulfillmentId }) => {
    return <CreatedDateColumn fulfillmentId={fulfillmentId} />;
  },
};
